import { render, staticRenderFns } from "./POSDetail.vue?vue&type=template&id=18038798&scoped=true&"
import script from "./POSDetail.vue?vue&type=script&lang=js&"
export * from "./POSDetail.vue?vue&type=script&lang=js&"
import style0 from "./POSDetail.vue?vue&type=style&index=0&id=18038798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18038798",
  null
  
)

export default component.exports